module.exports = __webpack_public_path__ + "static/media/icon-breaker-podcast.c5357e94.svg";